import axiosInstance from "../../../common/axiosInstance";
import { IGeneralResponse } from "../../../types/GenerateTypes";
import { IWordListsResponse } from "../../../types/word";
import { WordDetail } from "../type/WordDetailType";

export const fetchWordDetail = async (id: string): Promise<WordDetail> => {
  const { data } = await axiosInstance.get(`/words/${id}`);
  return data;
};
